import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { RoleEnum } from 'app/core/roles/role.types';
import { RoleService } from 'app/core/roles/role.service';
import { of, switchMap } from 'rxjs';

export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const roleService: RoleService = inject(RoleService);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                // Authenticated, but not an Administrator — redirect to the unauthorized page
                if (!roleService.isInRole([RoleEnum.Role.Administrator])) {
                    return of(router.parseUrl('unauthorized'));
                }

                // Allow the access
                return of(true);
            })
        );
};
